module.exports = __webpack_public_path__ + "static/media/showroom.d6b236ef.svg";